import DynamicLegal from "@/pages/legal/DynamicLegal";

export default function ShippingPayment() {
  return <DynamicLegal pageKey="shipping" />;
}
